module.exports = __webpack_public_path__ + "img/Weapon_291.9b0d0552.png";